// export const apiUrl = 'http://localhost:8420/api'; //local
// export const baseUrl = 'http://localhost:8420'; //local

// export const apiUrl = 'https://transac-back-dev.herokuapp.com/api'; // dev
// export const baseUrl = 'https://transac-back-dev.herokuapp.com/api'; // dev

export const apiUrl = 'https://transac230.herokuapp.com/api'; // prod
export const baseUrl = 'https://transac230.herokuapp.com'; // prod


export const googleId = '395225671324-fjsb0u6scid9nfifo44jeq66qrnj5npj.apps.googleusercontent.com'

export const prices = [{title: '$'},{title:'$$'},{title: '$$$'},{title: '$$$$'}];
export const transactions = [ { title: 'Pickup'},{title:'Delivery'},{title: 'Reservation'}];
export const positions = [ { title: 'Owner'},{title:'Manager'},{title: 'Cashier'}, { title: 'Crew' }];

export const marksWeekly = [{  value: 0,  label: `1w`,  val: 1,},{  value: 20,  label: `2w`,  val: 2,},{  value: 40,  label: `3w`,  val: 3,},{  value: 60,  label: `4w`,  val: 4,},{  value: 80,  label: `5w`,  val: 5,},{  value: 100,  label: `6w`,  val: 6,}];


export const Schedule = [{
    value: 'DAILY',
    label: 'Daily'
    },
    {
        value: 'WEEKLY',
        label: 'Weekly'
    },
    {
        value: 'MONTHLY',
        label: 'Monthly'
    }
]

export const AnsType = [{
    value: 'CHECKBOX',
    label: 'Checkbox'
    },
    {
        value: 'RADIO',
        label: 'Radio'
    },
    {
        value: 'YES_NO',
        label: 'Yes or No'
    }
]

export const TimeTable = [{
    value: 'IN',
    label: 'Check In'
    },
    {
        value: 'OUT',
        label: 'Check Out'
    },
  
]


export const required = [
    {
        name: 'Basic Informations',
        href: "/app/account?informations",
        id: 'basicInfo',
        message: 'Please provide Basic Personal Informations to continue'
    },
    {
        name: 'Current Address',
        href: "/app/account?address",
        id: 'address',
        message: 'Please provide Current Address to continue'
    },
    {
        name: 'Face Image',
        href: "/app/account?face",
        id: 'face',
        message: 'Please upload Clear Face Image to continue'
    },
    {
        name: 'Valid ID',
        href: "/app/account?validID",
        id: 'validId',
        message: 'Please upload Clear Valid ID Image to continue'
    },
    {
        name: 'Proof of Income',
        href: "/app/account?poi",
        id: 'poi',
        message: 'Please upload Clear Proof of Income Image to continue'
    }
]


export const gender = [
    {
        name: 'Male',
        value: "male"
    },
    {
        name: 'Female',
        value: "female"
    }
]

export const civilStatus = [
    {
        name: 'Single',
        value: "single"
    },
    {
        name: 'Married',
        value: "married"
    },
    {
        name: 'widowed',
        value: "widowed"
    },
    {
        name: 'Divorced',
        value: "divorced"
    }
]

export const monthly = [
    {
        name: '₱1,000-₱5,000',
        value: 1
    },
    {
        name: '₱10,000-₱20,000',
        value: 2
    },
    {
        name: '₱20,000-₱50,000',
        value: 3
    },
    {
        name: '₱50,000-₱100,000',
        value: 4
    },
    {
        name: '₱100,000-above',
        value: 5
    }
]

export const staticMsg = {
    unVerified: () => {
        return 'Your account is not yet verified, Provide all requirements clearly for faster verification from our office.'
    },
    unpaidLoan: (data) => {
        return `An outstanding loan with a loan ID - ${data.loanId} is still unpaid, please pay your remaining balance of ₱${Number(data.loanAmount - data.totalCollected)} to avail your next loan.`
    },
    reviewLoan: (data) => {
        return `You still have a pending loan request with a loan ID - ${data.loanId} waiting to be approved. We are already processing your application.`
    }
}


// export const questionnaire = [
//     { 
//       title: 'How do you feel today?',
//       children: [
//           { 
//             title: "I'm good", 
//             type: 'choices',
//           },
//           { 
//             title: 'I feel unwell', 
//             type: 'choices', 
//             children: [{ 
//                 title: 'Do you have any of the following?',
//                 subtitle: '(Flu,Fever,Cough,Colds,Difficulty Breathing, Loss of taste or loss of smell)',
//                 children: [
//                         { 
//                         title: 'Yes',
//                         type: 'choices', 
//                         children: [
//                             { title: 'Do you have household members who are experiencing symptoms similar to those mentioned in the previous question?',
//                               children: [
//                                   {
//                                       title: 'Yes',
//                                       type: 'choices',
//                                       children: [
//                                           { title: 'Do you live with a medical, police, or military frontliner?', 
//                                             children: [
//                                                 {
//                                                 title: 'Yes',
//                                                 type: 'choices',
//                                                 children: [
//                                                     { 
//                                                         title: 'Are you the assigned household member doing supply runs, and have done so in the last 14 days?',
//                                                         children: [
//                                                             {
//                                                             title: 'Yes',
//                                                             type: 'choices'
//                                                             },
//                                                             {
//                                                                 title: 'No',
//                                                                 type: 'choices'
//                                                                 },
//                                                     ]
//                                                      }
//                                                 ]
//                                                 },
//                                                 {
//                                                     title: 'No',
//                                                     type: 'choices',
//                                                     children: [
//                                                         { 
//                                                             title: 'Are you the assigned household member doing supply runs, and have done so in the last 14 days?',
//                                                             children: [
//                                                                 {
//                                                                 title: 'Yes',
//                                                                 type: 'choices'
//                                                                 },
//                                                                 {
//                                                                     title: 'No',
//                                                                     type: 'choices'
//                                                                     },
//                                                         ]
//                                                          }
//                                                     ]
//                                                     },
//                                             ]
//                                             }
//                                       ]
//                                   },
//                                   {
//                                     title: 'No',
//                                     type: 'choices',
//                                     children: [
//                                         { title: 'Do you live with a medical, police, or military frontliner?', 
//                                           children: [
//                                               {
//                                               title: 'Yes',
//                                               type: 'choices',
//                                               children: [
//                                                   { 
//                                                       title: 'Are you the assigned household member doing supply runs, and have done so in the last 14 days?',
//                                                       children: [
//                                                           {
//                                                           title: 'Yes',
//                                                           type: 'choices'
//                                                           },
//                                                           {
//                                                               title: 'No',
//                                                               type: 'choices'
//                                                               },
//                                                   ]
//                                                    }
//                                               ]
//                                               },
//                                               {
//                                                   title: 'No',
//                                                   type: 'choices',
//                                                   children: [
//                                                     { 
//                                                         title: 'Are you the assigned household member doing supply runs, and have done so in the last 14 days?',
//                                                         children: [
//                                                             {
//                                                             title: 'Yes',
//                                                             type: 'choices'
//                                                             },
//                                                             {
//                                                                 title: 'No',
//                                                                 type: 'choices'
//                                                                 },
//                                                     ]
//                                                      }
//                                                 ]
//                                                   },
//                                           ]
//                                           }
//                                     ]
//                                 }
//                               ]
//                             }
//                                 ]    
//                         },
//                         { 
//                             title: 'No',
//                             type: 'choices', 
//                         },
                    
//                     ]
//                 }]
//           },
//           { 
//             title: 'I need to talk to someone', 
//             type: 'choices', 
           
//           },
//         ] 
//     },
//     { title: 'Are going to the office today?', 
//       children: [
//           { title: 'Yes', type: 'choices', children: [
//               { title: 'Are you taking a private vehicle, walking, or biking to work?', children: [
//                   {title: 'Yes', type: 'choices'},
//                   {title: 'No', type: 'choices'}
//               ] }
//           ] },
//           { title: 'No', type: 'choices' }
//         ] 
// },
// { title: 'Are you part of an ongoing contact tracing activity?', 
// children: [
//     { title: 'Yes', type: 'choices', children: [
//         { title: 'Have you been cleared of Covid?', children: [
//             {title: 'Yes', type: 'choices'},
//             {title: 'No', type: 'choices'}
//         ] }
//     ] },
//     { title: 'No', type: 'choices' }
//   ] 
// },
// { title: 'Have you taken a PCR test during the past 14 days?', 
// children: [
//     { title: 'Yes', type: 'choices'},
//     { title: 'No', type: 'choices' }
//   ] 
// },
// ]